
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Member } from '../types/memberTypes';

interface TransferOwnershipDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  member?: Member;
  source?: 'portfolio' | 'business';
}

const TransferOwnershipDialog: React.FC<TransferOwnershipDialogProps> = ({
  open,
  onOpenChange,
  onConfirm,
  member,
  source = 'portfolio'
}) => {
  if (!member) return null;

  const entityType = source === 'portfolio' ? 'portfolio' : 'business';
  const entityTypeCapitalized = source === 'portfolio' ? 'Portfolio' : 'Business';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Transfer {entityTypeCapitalized} Ownership</DialogTitle>
          <DialogDescription>
            You are about to transfer ownership of this {entityType} to {member.firstName} {member.lastName}.
            They will become the Primary Owner and have full control over the {entityType}.
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <p className="text-sm text-gray-500">
            After this transfer, you will be changed to an Owner role with most of the same permissions,
            but {member.firstName} will be the Primary Owner with ultimate control of the {entityType}.
          </p>
          <p className="text-sm text-gray-500 mt-2">
            This action cannot be undone, though {member.firstName} could transfer ownership back
            to you in the future.
          </p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button 
            onClick={() => {
              onConfirm();
              onOpenChange(false);
            }}
          >
            Transfer Ownership
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default TransferOwnershipDialog;
